import ForecastAreaChart from "../../../../../src/core/ForecastAreaChart";
import { Playground } from 'docz';
import * as React from 'react';
export default {
  ForecastAreaChart,
  Playground,
  React
};